<template>
  <div class="section">
    <div class="order-complete">
      <DotLottieVue style="height: 160px; width: 160px" autoplay :speed="0.7" :data="checkAni" />
      <img :src="logo" />
      <div class="text">주문이 완료되었습니다!</div>
      <div class="order-num">
        주문번호 : &nbsp;<span class="num">{{ orderId }}</span>
      </div>
      <a href="/timeDeal" class="btn btn-lg btn-primary">상품 계속 보기</a>
    </div>
  </div>
</template>

<script setup>
import logo from '@/assets/images/logo.svg';
import checkAni from '../assets/images/check_ani.json';
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import Footer from '@/components/Footer.vue';
const orderId = history.state.orderId; // 여기서 받아야 함
</script>
